import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts';
import { Card } from '@/components/Card';

export function CampaignDeliveryChart({ sent, delivered, read, failed, title = 'Message performance' }: {
  sent: number; delivered: number; read: number; failed: number; title?: string;
}) {
  const data = [
    { name: 'Sent', value: sent, color: '#c8a552' },
    { name: 'Delivered', value: delivered, color: '#63a38a' },
    { name: 'Read', value: read, color: '#719dc0' },
    { name: 'Failed', value: failed, color: '#d27f79' },
  ];
  return <Card padded className="min-w-0">
    <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
      <div><h3 className="text-base font-semibold text-text-primary">{title}</h3><p className="mt-1 text-xs text-text-muted">Delivery and read receipts update when WhatsApp sends an event.</p></div>
      <div className="rounded-lg bg-success-soft px-3 py-2 text-xs text-success">{sent ? `${Math.round(delivered / sent * 100)}% delivered` : 'No sends yet'}</div>
    </div>
    <div className="h-56" role="img" aria-label={data.map(item => `${item.name}: ${item.value}`).join(', ')}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 10, bottom: 0, left: -20 }} barSize={48}>
          <CartesianGrid strokeDasharray="3 5" vertical={false} stroke="var(--color-border, #ece9e2)" />
          <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#8a8a90' }} />
          <YAxis allowDecimals={false} axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: '#8a8a90' }} />
          <Tooltip cursor={{ fill: '#c8a5520d' }} contentStyle={{ borderRadius: 12, border: '1px solid #e9e6df', fontSize: 12 }} />
          <Bar dataKey="value" name="Messages" radius={[6, 6, 0, 0]}>{data.map(item => <Cell key={item.name} fill={item.color} />)}</Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  </Card>;
}
